// extracted by mini-css-extract-plugin
export var actions = "_jw-g";
export var benefitCard = "_jw-b";
export var benefitIcon = "_jw-d";
export var benefitLabel = "_jw-f";
export var benefits = "_jw-a";
export var benefitsSection = "_jw-8";
export var bodyText = "_jw-7";
export var closeButton = "_jw-2";
export var content = "_jw-3";
export var eyebrow = "_jw-4";
export var heading = "_jw-5";
export var image = "_jw-i";
export var imagePanel = "_jw-h";
export var modal = "_jw-0";
export var offerCard = "_jw-c";
export var offerIcon = "_jw-e";
export var sectionLabel = "_jw-9";
export var shell = "_jw-1";
export var title = "_jw-6";